import { useMutation } from 'react-query'

// Services
import { GetDocumentChunks } from 'services/api/Ai'

export default () => {
  const {
    mutate: getDocumentChunks,
    data: getDocumentChunksData,
    error: getDocumentChunksError,
    isLoading: isGetDocumentChunksLoading,
    isSuccess: isGetDocumentChunksSuccess,
    isError: isGetDocumentChunksError,
  } = useMutation(GetDocumentChunks)

  return {
    getDocumentChunks,
    getDocumentChunksData,
    getDocumentChunksError,
    isGetDocumentChunksLoading,
    isGetDocumentChunksSuccess,
    isGetDocumentChunksError,
  }
}
